module.exports = __webpack_public_path__ + "img/Lot6.761c5cf9.jpg";